var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 107.73 100.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#495e67;}.cls-2{fill:#5c7581;}.cls-3{fill:#5b7480;}.cls-4{fill:#4a5f6a;}.cls-5{fill:url(#radial-gradient);}.cls-6{mix-blend-mode:screen;}.cls-7{fill:#a2c0ed;mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 56.78,
    cy: 48.43,
    r: 46.56,
    gradientTransform: "matrix(0.95, -0.31, 0.19, 0.59, -6.52, 37.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7495d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30407d"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Computer_01b",
    "data-name": "Computer_01b",
    viewBox: "0 0 107.73 100.66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.99 36.51 5.99 93.21 107.73 60.16 107.73 3.46 5.99 36.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 33.06 5.99 36.51 107.73 3.46 101.74 0 0 33.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 33.06 5.99 36.51 5.99 93.21 0 89.76 0 33.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.94 92.78 32.92 97.96 89.77 79.49 80.8 74.31 23.94 92.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.94 92.78 23.94 95.48 32.92 100.66 32.92 97.96 23.94 92.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "89.77 79.49 89.77 82.19 32.92 100.66 32.92 97.96 89.77 79.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.86 77.66 53.86 88.46 62.84 85.54 62.84 74.74 53.86 77.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.87 78.63 50.87 86.73 53.86 88.46 53.86 77.66 50.87 78.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "11.97 39.97 11.81 86.07 101.3 56.89 101.74 10.8 11.97 39.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.7 44.5 16.66 60.02 40.92 52.11 41.04 36.59 16.7 44.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.66 62.72 16.61 64.57 40.88 56.66 41 54.81 16.66 62.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.66 66.91 16.61 68.76 40.88 60.84 41 59 16.66 66.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.66 71.1 16.61 72.95 40.88 65.03 41 63.19 16.66 71.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.66 75.29 16.61 77.14 40.88 69.22 41 67.38 16.66 75.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.38 53.33 44.34 68.85 68.6 60.94 68.72 45.42 44.38 53.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.34 35.03 44.3 36.88 68.56 28.97 68.68 27.13 44.34 35.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.34 39.23 44.3 41.07 68.56 33.16 68.68 31.32 44.34 39.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.34 43.41 44.3 45.26 68.56 37.35 68.68 35.51 44.34 43.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.34 47.6 44.3 49.45 68.56 41.54 68.68 39.7 44.34 47.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "72.17 43.71 72.13 45.56 96.39 37.65 96.52 35.8 72.17 43.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "72.17 47.9 72.13 49.75 96.39 41.84 96.52 39.99 72.17 47.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "72.17 52.09 72.13 53.94 96.39 46.03 96.52 44.19 72.17 52.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "72.17 56.28 72.13 58.13 96.39 50.22 96.52 48.38 72.17 56.28"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 107.73,
    height: 100.66,
    xlinkHref: "#Computer_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor1);
export default __webpack_public_path__ + "static/media/monitor-1.eb2b0f0ee6820e417f4ced389d81d353.svg";
export { ForwardRef as ReactComponent };